import { Injectable } from '@angular/core';

import { GeoLoc } from '../interfaces/geoloc.model';

@Injectable({
    providedIn: 'root'
})
export class UtilsService {

    /**
     * generates logo name from store name for https://logo.clearbit.com/{{logo}}
     * @param store store name
     */
    getStoreLogoName(store: string): string {
        if (store.toLowerCase().startsWith('walmart')) {
            return 'walmart.com';
        }

        if (store.toLowerCase().startsWith('cvs')) {
            return 'cvs.com';
        }

        if (store.toLowerCase().startsWith('rite aid')) {
            return 'riteaid.com';
        }

        if (store.toLowerCase().startsWith('bartell drugs')) {
            return 'bartelldrugs.com';
        }

        switch (store.toLocaleLowerCase()) {
            case 'iga':
                return 'iga.net';
            default:
                return `${store.replace(/ /g, '')}.com`;
        }
    }

    /**
     * converts location string ("lat,long") to Location object
     * @param locationStr location string
     */
    convertLocation(locationStr: string): GeoLoc {
        const loc = locationStr.split(',');
        if (loc.length !== 2) {
            return null;
        }

        return {
            latitude: parseFloat(loc[0]),
            longitude: parseFloat(loc[1])
        };
    }

    translate(pageName, locale, doc) {
        let content = {};
        console.log(locale)
        if(locale?.value) {
            locale = locale.value.split('-').slice(0,1).join(' ')
        }else {
            locale = locale.split('-').slice(0,1).join(' ')
        }
        const entries = Object.entries(doc);

        entries.forEach(entry => {
            content[entry[0]] = entry[1][locale]; 
        })
        
        return content
    }
}
